if (!customElements.get('product-size-chart')) {
  customElements.define('product-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.controls = this.querySelector('.cc-size-chart__units');
      this.buttons = Array.from(this.querySelectorAll('button[data-unit]'));
      this.cells = Array.from(this.querySelectorAll('[data-cm][data-inch]'));
      this.status = this.querySelector('[role="status"]');
      if (!this.controls || this.buttons.length !== 2 || !this.cells.length) return;
      this.initialized = true;
      this.unit = 'inch';
      this.buttons.forEach(button => button.addEventListener('click', () => this.setUnit(button.dataset.unit)));
      this.controls.hidden = false;
    }

    setUnit(unit) {
      if (!['cm', 'inch'].includes(unit) || unit === this.unit) return;
      this.cells.forEach(cell => {
        cell.textContent = cell.dataset[unit];
      });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.unit === unit)));
      this.unit = unit;
      if (this.status) this.status.textContent = unit === 'cm' ? this.dataset.statusCm : this.dataset.statusInch;
    }
  });
}
